 



// THIS CODE IS GENERATED.  CHANGES MADE TO THIS FILE WILL BE LOST.

import { Injectable } from '@angular/core';

import { ClientBase } from '../shared/core/ovs.core';
import { ResortInventory } from '../models/presentation.model';

export abstract class ResortInventoryClientBase extends ClientBase
{
    public abstract Get(resortId: string, startDate: Date,  success?: (value: Array<ResortInventory>) => void, error?: (error: any) => void): void;
}

@Injectable()
export class ResortInventoryClient extends ResortInventoryClientBase
{
    public Get(resortId: string, startDate: Date,  success?: (value: Array<ResortInventory>) => void, error?: (error: any) => void): void
	{
        let params: any = {};
        params.resortId = resortId;

        let dateNow = new Date();
        if (startDate === null || startDate === undefined || startDate < new Date() || isNaN(startDate.getTime()))
            params.startDate = new Date(dateNow.getTime() - 60000 * dateNow.getTimezoneOffset()).toISOString();
        else
            params.startDate = startDate ? new Date(startDate.getTime() - 60000 * startDate.getTimezoneOffset()).toISOString() : undefined;
        params.breakIt = 0;
        this.baseGetArray<ResortInventory>("api/ResortInventory", ResortInventory, params, success, error);
	}
}







// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/resort-inventory.client.ts